import { config } from "./config";

export async function saveInquiry(inquiry) {
  // const primary = "https://ashtechprojectnoida.com/ashtech/api/inquiries"

  const primary = `${config.apiUrl}`;
  const fallback = "/api/inquiries"

  async function post(url) {
    const resp = await fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(inquiry),
    })

    console.log('inquiry:',inquiry);
    console.log(resp);

    if (!resp.ok) {
      const text = await resp.text()
      throw new Error(text || `Request failed with status ${resp.status}`)
    }

    return resp.json()
  }

  try {
    return await post(primary)
  } catch (err) {
    // If the failure was a network-level error (e.g. connection refused), try a relative path fallback.
    if (err instanceof TypeError) {
      try {
        return await post(fallback)
      } catch (err2) {
        throw new Error(
          `Network error: failed to reach ${primary} and fallback ${fallback}. ${err2.message}`
        )
      }
    }

    // Re-throw other errors (HTTP errors with response body)
    throw err
  }
}
